package game.controller

import com.soywiz.korau.sound.SoundChannel
import com.soywiz.korge.input.Input
import com.soywiz.korio.async.launchImmediately
import game.*
import view.Terminal

class TitleController : GameController() {
    private lateinit var titleScroll: TitleScroll
    private var scrollCooldown = 0
    private lateinit var titleRoom: Room
    private lateinit var musicSoundChannel: SoundChannel

    override fun onActivate(game: Game) {
        titleScroll = TitleScroll(game, 78)
        titleRoom = game.getRoomById("title")
        game.launchImmediately {
            musicSoundChannel = game.getSound("the-lost-father").play()
            showTitleButtons(game)
        }
    }

    override fun onRender(game: Game, terminal: Terminal) {
        terminal.clear(CgaColor.BLACK)
        terminal.drawDoubleBorder(0, 0, 79, 24, CgaColor.YELLOW, CgaColor.BLACK)
        titleRoom.render(terminal, 3, 2, 0, 10, 50, 3)
        terminal.drawString(7, 6, game.text("Title_Tag"), CgaColor.LIGHT_GRAY, CgaColor.BLACK)
        titleScroll.render(terminal, 1, 14)
        terminal.setChar(39, 20, 2, CgaColor.LIGHT_BLUE, CgaColor.WHITE)
        val copyright = game.text("Copyright")
        terminal.drawString(78 - copyright.length, 24, copyright, CgaColor.YELLOW, CgaColor.BLACK)
    }

    override fun onTick(game: Game, input: Input) {
        if (scrollCooldown > 0) {
            scrollCooldown--
        } else {
            titleScroll.scrollLeft()
            scrollCooldown = 25
        }
    }

    private suspend fun showTitleButtons(game: Game) {
        removeAllComponents()

        for (saveId in SaveId.values()) {
            val saveGame = try {
                loadState(saveId)
            } catch (e: Exception) {
                null
            }
            val label = if (saveGame != null) {
                "\u0003 ${saveGame.playerLife}/${saveGame.playerMaxLife}"
            } else {
                game.text("Title_NewGame", saveId.ordinal + 1)
            }

            addButton(label, saveId.ordinal * 24 + 6, 9, 20, 3) {
                game.launchImmediately {
                    musicSoundChannel.stop()
                    val gameState = loadState(saveId)

                    if (gameState == null) {
                        game.newGame(saveId)
                    } else {
                        game.loadGame(saveId)
                    }
                }
            }
        }

        addButton(game.text("Title_Settings"), 54, 1, 20, 3) {
            game.controller = SettingsController()
        }

        addButton(game.text("Title_DeleteGame"), 54, 5, 20, 3) {
            game.launchImmediately {
                showDeleteButtons(game)
            }
        }
    }

    private suspend fun showDeleteButtons(game: Game) {
        removeAllComponents()

        for (saveId in SaveId.values()) {
            val saveGame = loadState(saveId)
            val label = if (saveGame != null) {
                "\u0003 ${saveGame.playerLife}/${saveGame.playerMaxLife}"
            } else {
                game.text("Title_Empty", saveId.ordinal + 1)
            }

            addButton(label, saveId.ordinal * 24 + 6, 9, 20, 3) {
                game.launchImmediately {
                    deleteFile(saveId.fileName)
                    showDeleteButtons(game)
                }
            }
        }

        addButton(game.text("Title_CancelDelete"), 54, 5, 20, 3) {
            game.launchImmediately {
                showTitleButtons(game)
            }
        }
    }
}